/* =============================================
   MUUVE Your Color — Event JS v5
   Shopify Assets: muuve-event.js
   ============================================= */

(function () {
  'use strict';

  /* ─────────────────────────────
     1. 데이터 정의
  ───────────────────────────── */
  const CHAIRS = [
  { id: 'dark-gray',            name: '다크 그레이',            img: 'https://cdn.shopify.com/s/files/1/0865/4408/9378/files/muuve-dark-gray.jpg?v=1778216421' },
{ id: 'dark-green',           name: '다크 그린',              img: 'https://cdn.shopify.com/s/files/1/0865/4408/9378/files/muuve-dark-green.jpg?v=1778216421' },
{ id: 'deep-khaki',           name: '딥 카키',                img: 'https://cdn.shopify.com/s/files/1/0865/4408/9378/files/muuve-deep-khaki.jpg?v=1778216421' },
{ id: 'deep-khaki-gray',      name: '딥 카키 그레이',         img: 'https://cdn.shopify.com/s/files/1/0865/4408/9378/files/muuve-deep-khaki-gray.jpg?v=1778216421' },
{ id: 'deep-khaki-black',     name: '딥 카키 블랙',           img: 'https://cdn.shopify.com/s/files/1/0865/4408/9378/files/muuve-deep-khaki-black.jpg?v=1778216421' },
{ id: 'red',                  name: '레드',                   img: 'https://cdn.shopify.com/s/files/1/0865/4408/9378/files/muuve-red.jpg?v=1778216421' },
{ id: 'mid-dark-gray',        name: '미드 다크 그레이',       img: 'https://cdn.shopify.com/s/files/1/0865/4408/9378/files/muuve-mid-dark-gray.jpg?v=1778216421' },
{ id: 'beige',                name: '베이지',                 img: 'https://cdn.shopify.com/s/files/1/0865/4408/9378/files/muuve-beige.jpg?v=1778216421' },
{ id: 'black',                name: '블랙',                   img: 'https://cdn.shopify.com/s/files/1/0865/4408/9378/files/muuve-black.jpg?v=1778216421' },
{ id: 'black-deep-khaki',     name: '블랙 딥 카키',           img: 'https://cdn.shopify.com/s/files/1/0865/4408/9378/files/muuve-black-deep-khaki.jpg?v=1778216421' },
{ id: 'yellow-mustard',       name: '옐로우 머스타드',        img: 'https://cdn.shopify.com/s/files/1/0865/4408/9378/files/muuve-yellow-mustard.jpg?v=1778216421' },
{ id: 'yellow-mustard-black', name: '옐로우 머스타드 블랙',   img: 'https://cdn.shopify.com/s/files/1/0865/4408/9378/files/muuve-yellow-mustard-black.jpg?v=1778216421' },
{ id: 'pale-sky-blue',        name: '페일 스카이 블루',       img: 'https://cdn.shopify.com/s/files/1/0865/4408/9378/files/muuve-pale-sky-blue.jpg?v=1778216421' },
{ id: 'pale-sky-blue-gray',   name: '페일 스카이 블루 그레이',img: 'https://cdn.shopify.com/s/files/1/0865/4408/9378/files/muuve-pale-sky-blue-gray.jpg?v=1778216421' },
{ id: 'pink',                 name: '핑크',                   img: 'https://cdn.shopify.com/s/files/1/0865/4408/9378/files/muuve-pink.jpg?v=1778216421' },
  ];

  const TENDENCIES = [
    { id: 'harmony', label: '공간과 조화를 이루는 컬러를 선택한다' },
    { id: 'point',   label: '공간의 주인공이 되는 포인트 컬러를 선택한다' },
    { id: 'variety', label: '교체 가능한 커버가 있다면 다양한 컬러도 시도해본다' },
  ];

  /* ─────────────────────────────
     2. 상태
  ───────────────────────────── */
  const S = {
    name:           '',
    phone:          '',
    agreedPrivacy:  false,
    interiorStyle:  '',
    tendency:       null,
    tendencyLabel:  '',
    colorId:        null,
    colorName:      '',
    sheetSaved:     false,
  };

  // window.MUUVE는 muuve-event.liquid에서 Liquid로 주입
  const M = window.MUUVE || {
    isLoggedIn:   false,
    customerId:   null,
    loginUrl:     '/account/login',
    registerUrl:  '/account/register',
    sheetsUrl:    '',
    privacyUrl:   '/policies/privacy-policy',
    assetUrl:     function (f) { return '/cdn/shop/files/' + f; },
  };

  /* ─────────────────────────────
     3. 유틸
  ───────────────────────────── */
  function $(id) { return document.getElementById(id); }

  let toastTimer;
  function showToast(msg, duration) {
    const el = $('muuve-toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-show'), duration || 2400);
  }

  function assetUrl(file) {
    return M.assetUrl ? M.assetUrl(file) : '/cdn/shop/files/' + file;
  }

  function formatPhone(val) {
    const num = val.replace(/\D/g, '').slice(0, 11);
    if (num.length <= 3) return num;
    if (num.length <= 7) return num.slice(0, 3) + '-' + num.slice(3);
    return num.slice(0, 3) + '-' + num.slice(3, 7) + '-' + num.slice(7);
  }

  function isValidPhone(val) {
    return /^01[0-9]-\d{3,4}-\d{4}$/.test(val);
  }

  /* ─────────────────────────────
     4. 진행 바
  ───────────────────────────── */
  function updateProg(step) {
    const prog  = $('muuve-prog');
    const fill  = $('muuve-prog-fill');
    const label = $('muuve-prog-label');
    if (!prog) return;
    if (step === 0) { prog.classList.remove('is-visible'); return; }
    prog.classList.add('is-visible');
    fill.style.width = (step / 3 * 100) + '%';
    label.textContent = step + ' / 3';
  }

  /* ─────────────────────────────
     5. 페이지 전환
  ───────────────────────────── */
  function showPage(id) {
    document.querySelectorAll('.muuve__page')
      .forEach(p => p.classList.remove('is-active'));
    const page = document.getElementById(id);
    if (page) page.classList.add('is-active');
    // 설문 섹션 위치로 스크롤
    const survey = $('muuve-survey');
    if (survey && id !== 'muuve-hero') {
      setTimeout(() => survey.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
    }
  }

  /* ─────────────────────────────
     6. 시작 버튼 클릭
  ───────────────────────────── */
  function startEvent() {
    if (!M.isLoggedIn) {
      showPage('muuve-login-wall');
      updateProg(0);
    } else {
      showPage('muuve-step0');
      updateProg(0);
    }
  }

  function buildChairGrid() {
    const grid = $('muuve-chair-grid');
    if (!grid) return;
    grid.innerHTML = CHAIRS.map(c => `
      <div class="muuve__chair-item"
           data-id="${c.id}" data-name="${c.name}"
           onclick="MuuveEvent.selectChair(this)">
        <img class="muuve__chair-img"
             src="${c.img}"
             alt="${c.name}" loading="lazy"
             onclick="event.stopPropagation(); MuuveEvent.openImgModal('${c.img}', '${c.name}', '${c.id}')">
        <div class="muuve__chair-name">${c.name}</div>
      </div>
    `).join('');
  }

  /* ─────────────────────────────
     이미지 모달
  ───────────────────────────── */
  function openImgModal(src, name, id) {
    let modal = $('muuve-img-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'muuve-img-modal';
      modal.className = 'muuve__img-modal';
      modal.innerHTML = `
        <div class="muuve__img-modal-backdrop" onclick="MuuveEvent.closeImgModal()"></div>
        <div class="muuve__img-modal-content">
          <button class="muuve__img-modal-close" onclick="MuuveEvent.closeImgModal()">✕</button>
          <img class="muuve__img-modal-img" id="muuve-img-modal-img" src="" alt="">
          <p class="muuve__img-modal-name" id="muuve-img-modal-name"></p>
        </div>
      `;
      document.body.appendChild(modal);
    }
    $('muuve-img-modal-img').src = src;
    $('muuve-img-modal-img').alt = name;
    $('muuve-img-modal-name').textContent = name;
    modal.classList.add('is-open');
    modal.dataset.selectedId = id;
    document.body.style.overflow = 'hidden';
  }

  function closeImgModal() {
    const modal = $('muuve-img-modal');
    if (modal) {
      // 모달에 저장된 의자 id로 자동 선택
      const id = modal.dataset.selectedId;
      if (id) {
        const item = document.querySelector(`.muuve__chair-item[data-id="${id}"]`);
        if (item) selectChair(item);
      }
      modal.classList.remove('is-open');
    }
    document.body.style.overflow = '';
  }

  /* ─────────────────────────────
     8. Step 2 — 텍스트 카드 빌드
  ───────────────────────────── */
  function buildTendencyCards() {
    const wrap = $('muuve-tendency-wrap');
    if (!wrap) return;
    wrap.innerHTML = TENDENCIES.map((t, i) => `
      <div class="muuve__text-choice"
           data-id="${t.id}" data-label="${t.label}"
           onclick="MuuveEvent.selectTendency(this)">
        <div class="muuve__text-choice-num">${i + 1}</div>
        <div class="muuve__text-choice-text">${t.label}</div>
      </div>
    `).join('');
  }

  /* ─────────────────────────────
     9. Step 0 — 유효성 검사 및 다음
  ───────────────────────────── */
  function validateStep0() {
    let valid = true;

    // 이름
    const nameInput = $('muuve-input-name');
    const nameErr   = $('muuve-err-name');
    if (!nameInput.value.trim()) {
      nameInput.classList.add('is-error');
      nameErr.classList.add('is-visible');
      valid = false;
    } else {
      nameInput.classList.remove('is-error');
      nameErr.classList.remove('is-visible');
    }

    // 연락처
    const phoneInput = $('muuve-input-phone');
    const phoneErr   = $('muuve-err-phone');
    if (!isValidPhone(phoneInput.value)) {
      phoneInput.classList.add('is-error');
      phoneErr.classList.add('is-visible');
      valid = false;
    } else {
      phoneInput.classList.remove('is-error');
      phoneErr.classList.remove('is-visible');
    }

    // 동의
    const agreeCheck = $('muuve-agree');
    const agreeErr   = $('muuve-err-agree');
    if (!agreeCheck.checked) {
      agreeErr.classList.add('is-visible');
      valid = false;
    } else {
      agreeErr.classList.remove('is-visible');
    }

    if (!valid) return;

    S.name  = nameInput.value.trim();
    S.phone = phoneInput.value;
    S.agreedPrivacy = true;

    showPage('muuve-step1');
    updateProg(1);
  }

  /* ─────────────────────────────
     10. Step 1 — 주관식 다음
  ───────────────────────────── */
  function validateStep1() {
    const textarea = $('muuve-textarea-style');
    if (!textarea.value.trim()) {
      textarea.classList.add('is-error');
      showToast('인테리어 취향을 입력해주세요');
      return;
    }
    S.interiorStyle = textarea.value.trim();
    showPage('muuve-step2');
    updateProg(2);
  }

  /* ─────────────────────────────
     11. 선택 핸들러
  ───────────────────────────── */
  function selectTendency(el) {
    document.querySelectorAll('.muuve__text-choice')
      .forEach(c => c.classList.remove('is-selected'));
    el.classList.add('is-selected');
    S.tendency      = el.dataset.id;
    S.tendencyLabel = el.dataset.label;
    $('muuve-next2').classList.remove('is-disabled');
  }

  function selectChair(el) {
    document.querySelectorAll('.muuve__chair-item')
      .forEach(c => c.classList.remove('is-selected'));
    el.classList.add('is-selected');
    S.colorId   = el.dataset.id;
    S.colorName = el.dataset.name;
    $('muuve-next3').classList.remove('is-disabled');
  }

  /* ─────────────────────────────
     12. Step 3 완료 → 결과
  ───────────────────────────── */
  function goResult() {
    if (!S.colorId) return;
    saveToSheets();
    renderResult();
    showPage('muuve-result');
    updateProg(0);
  }

  /* ─────────────────────────────
     13. 결과 렌더링
  ───────────────────────────── */
  function renderResult() {
    const chair = CHAIRS.find(c => c.id === S.colorId);
    if (!chair) return;

    const imgEl  = $('muuve-result-chair-img');
    const nameEl = $('muuve-result-color-name');
    if (imgEl)  { imgEl.src = chair.img; imgEl.alt = chair.name; }
    if (nameEl) nameEl.textContent = chair.name;
  }

  /* ─────────────────────────────
     14. Google Sheets 저장
  ───────────────────────────── */
  function saveToSheets() {
    if (S.sheetSaved || !M.sheetsUrl || M.sheetsUrl === 'YOUR_APPS_SCRIPT_URL_HERE') {
      if (!M.sheetsUrl || M.sheetsUrl === 'YOUR_APPS_SCRIPT_URL_HERE') {
        console.warn('[MUUVE] sheetsUrl이 설정되지 않았습니다.');
      }
      return;
    }

    const payload = {
      action:         'save',
      customerId:     M.customerId,
      name:           S.name,
      phone:          S.phone,
      interiorStyle:  S.interiorStyle,
      tendency:       S.tendency,
      tendencyLabel:  S.tendencyLabel,
      colorId:        S.colorId,
      colorName:      S.colorName,
      timestamp:      new Date().toISOString(),
    };

    fetch(M.sheetsUrl, {
      method:  'POST',
      mode:    'no-cors',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(payload),
    })
    .then(() => { S.sheetSaved = true; })
    .catch(err => console.error('[MUUVE] Sheets 저장 실패:', err));
  }

  /* ─────────────────────────────
     15. 폰 번호 입력 이벤트
  ───────────────────────────── */
  function initPhoneInput() {
    const input = $('muuve-input-phone');
    if (!input) return;
    input.addEventListener('input', function () {
      const formatted = formatPhone(this.value);
      this.value = formatted;
      // 다음 버튼 활성화 체크
      checkStep0Ready();
    });
  }

  function checkStep0Ready() {
    const name  = ($('muuve-input-name')  || {}).value || '';
    const phone = ($('muuve-input-phone') || {}).value || '';
    const agree = ($('muuve-agree')       || {}).checked || false;
    const btn   = $('muuve-next0');
    if (!btn) return;
    if (name.trim() && isValidPhone(phone) && agree) {
      btn.classList.remove('is-disabled');
    } else {
      btn.classList.add('is-disabled');
    }
  }

  /* ─────────────────────────────
     16. Step 1 글자 수 카운트
  ───────────────────────────── */
  function initTextareaCount() {
    const ta    = $('muuve-textarea-style');
    const count = $('muuve-textarea-count');
    const next  = $('muuve-next1');
    if (!ta) return;

    ta.addEventListener('input', function () {
      const len = this.value.length;
      if (count) count.textContent = len + ' / 100';
      if (next) {
        if (this.value.trim()) {
          next.classList.remove('is-disabled');
        } else {
          next.classList.add('is-disabled');
        }
      }
    });
  }

  /* ─────────────────────────────
     17. 초기화
  ───────────────────────────── */
  function init() {
    buildChairGrid();
    buildTendencyCards();
    initPhoneInput();
    initTextareaCount();

    // 체크박스 변경 시 버튼 상태 갱신
    const agreeEl = $('muuve-agree');
    if (agreeEl) agreeEl.addEventListener('change', checkStep0Ready);

    const nameEl = $('muuve-input-name');
    if (nameEl) nameEl.addEventListener('input', checkStep0Ready);
  }

  /* ─────────────────────────────
     18. 전역 노출
  ───────────────────────────── */
  window.MuuveEvent = {
    startEvent,
    validateStep0,
    validateStep1,
    selectTendency,
    selectChair,
    goResult,
    openImgModal,
    closeImgModal,
    goStep: function (step) {
      if (step === 2 && !S.tendency) return;
      showPage('muuve-step' + step);
      updateProg(step);
    },
    goBack: function (step) {
      showPage('muuve-step' + step);
      updateProg(step);
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

